import React from 'react';
import { IconProps } from '../../../lib/types';

const ExternalLink: React.FC<IconProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16.561"
      height="16.561"
      viewBox="0 0 16.561 16.561"
      className={className}
    >
      <path
        d="M10.35 1.774a.887.887 0 010-1.774h5.323a.886.886 0 01.887.887V6.21a.887.887 0 01-1.774 0V3.027L7.4 10.354a.8.8 0 01-1.224 0 .855.855 0 010-1.224l7.36-7.356zM0 3.253a2.07 2.07 0 012.07-2.07h4.14a.887.887 0 010 1.774H2.07a.3.3 0 00-.3.3V14.49a.3.3 0 00.3.3h11.238a.3.3 0 00.3-.3v-4.14a.887.887 0 111.774 0v4.14a2.071 2.071 0 01-2.07 2.07H2.07A2.071 2.071 0 010 14.49z"
      ></path>
    </svg>
  );
};

export default ExternalLink;
